import texts from './m60sInfraredTexts.json'
import base from './m60sReportTexts.json'
export const IR_CODES = ['front_shoulder_neck', 'back_shoulder_neck', 'chest', 'abdomen', 'spine', 'waist']
const names = ['frontShoulderNeck', 'backShoulderNeck', 'chest', 'abdomen', 'spine', 'waist']
const aliases = { shoulder_neck: 'front_shoulder_neck', front_chest: 'chest', front_abdomen: 'abdomen', back_spine: 'spine', back_waist: 'waist' }
export const number = value => (typeof value === 'number' || (typeof value === 'string' && value.trim())) && Number.isFinite(Number(value)) ? Number(value) : null
export function infraredText(locale, key, params = {}) {
    const lang = locale === 'pt-PTO' ? 'pt-PT' : locale
    const text = (texts[lang] || {})[key] || (base[lang] || {})[key] || texts['en-US'][key] || base['en-US'][key] || key
    return text.replace(/\{([^{}]+)\}/g, (match, name) => params[name] === undefined ? match : String(params[name]))
}
export function frameParts(frame = {}) {
    const current = Array.isArray(frame.regions)
    const rows = current ? frame.regions : (frame.parts || [])
    return IR_CODES.map((code, i) => {
        const row = rows.find(p => (aliases[p.partCode] || p.partCode || p.code) === code)
        if (!row) return null
        const extra = {}
        for (const field of ['regionAvgTemp', 'regionMaxTemp', 'regionMinTemp', 'regionTempDiff', 'leftAvgTemp', 'rightAvgTemp', 'leftRightTempDiff']) {
            const raw = number(row[field])
            extra[field] = raw === null ? null : current ? raw : Math.round((field.endsWith('Diff') ? Math.abs(raw) * 5 / 9 : (raw - 32) * 5 / 9) * 100) / 100
        }
        extra.supportsAsymmetry = code !== 'spine' && ['leftAvgTemp', 'rightAvgTemp', 'leftRightTempDiff'].every(k => extra[k] !== null)
        return { code, nameKey: 'infrared.part.' + names[i], view: ['front_shoulder_neck', 'chest', 'abdomen'].includes(code) ? 'front' : 'back', value: extra.regionAvgTemp, extra }
    }).filter(Boolean)
}
export function temperature(value, imperial, difference = false) {
    const n = number(value)
    return n === null ? '—' : (imperial ? n * 9 / 5 + (difference ? 0 : 32) : n).toFixed(1) + (imperial ? '°F' : '°C')
}
